import { Clickable } from '@ahmdigital/ui';
import React from 'react';

import constants from '../../../../../ahm-constants';

const otherSavingsData = [
  {
    analyticsLabel: 'youth-discount',
    body: (
      <>
        If you are 18 to 29 and a Principal member or partner, you might qualify for the Youth Discount on your private
        health insurance. The Youth Discount only applies to hospital cover or the hospital component of a package – it
        doesn’t apply to extras. If you keep continuous hospital cover, you’ll maintain the Youth Discount until you
        turn 41.{' '}
        <Clickable analytics={{ label: 'Youth Discount link' }} to={constants.URLS.SALES.YOUTH_DISCOUNT}>
          Learn more about Youth Discount
        </Clickable>
      </>
    ),
    title: 'Youth Discount',
  },
  {
    analyticsLabel: 'agr',
    body: (
      <>
        The Australian Government Rebate is an amount the government contributes towards health insurance premiums to
        make it more affordable. If you’re eligible, you can choose to get the rebate upfront by paying reduced premiums
        or it can be refunded as a tax offset when you lodge your tax return.{' '}
        <Clickable inNewTab analytics={{ label: 'What is AGR link' }} to={constants.URLS.HELP.WHAT_IS_AGR}>
          Learn more about the AGR
        </Clickable>
      </>
    ),
    title: 'The Australian Government Rebate (AGR) on private health insurance',
  },
  {
    analyticsLabel: 'lhc',
    body: (
      <>
        Lifetime Health Cover (LHC) loading is to encourage Australians to take out hospital cover early, by charging
        you extra if you take out hospital cover after 1 July following your 31st birthday. Join ahm before then and you
        can lose the loading.{' '}
        <Clickable inNewTab analytics={{ label: 'What is LHC link' }} to={constants.URLS.HELP.WHAT_IS_LHC}>
          Learn more about LHC loading
        </Clickable>
      </>
    ),
    title: 'Lifetime Health Cover (LHC) loading',
  },
];

export default otherSavingsData;
